module.exports = {
  airport: "airport",
  ATM: "ATM",
  attraction: "attraction",
  bank: "bank",
  bus: "bus",
  bar: "bar",
  beach: "beach",
  cafe: "cafe",
  cinema: "cinema",
  cemetery: "cemetery",
  gas: "gas",
  groceries: "groceries",
  gym: "gym",
  hospital: "hospital",
  hotel: "hotel",
  mall: "mall",
  museum: "museum",
  park: "park",
  pharmacy: "pharmacy",
  port: "port",
  restaurant: "restaurant",
  school: "school",
  sports: "sports",
  stadium: "stadium",
  store: "store",
  train: "train",
  temple: "temple",
  university: "university",
  other: "other",
};
